import { ethers } from 'ethers';
import { getNetworkProvider } from '../../../lib/eth';
export async function getTargetNetworkProvider(chainId) {
    const networkProvider = await getNetworkProvider(chainId);
    return new ethers.providers.Web3Provider(networkProvider);
}
//# sourceMappingURL=getTargetNetworkProvider.js.map